import { render, staticRenderFns } from "./InvestorMutualFunds.vue?vue&type=template&id=e7b9ab74&scoped=true&"
import script from "./InvestorMutualFunds.vue?vue&type=script&lang=js&"
export * from "./InvestorMutualFunds.vue?vue&type=script&lang=js&"
import style0 from "./InvestorMutualFunds.vue?vue&type=style&index=0&id=e7b9ab74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b9ab74",
  null
  
)

export default component.exports